import { Linkedin, Twitter, Github, ArrowUpRight } from "lucide-react";

const cols = [
  {
    title: "Solutions",
    links: ["AI-Driven Automation", "Cloud Technologies", "Cybersecurity", "Telecom Solutions", "Enterprise Software"],
  },
  {
    title: "Company",
    links: ["About", "Expertise", "Industries", "Engagement", "Contact"],
  },
];

export const Footer = () => {
  const go = (href) => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  return (
    <footer className="relative z-10 border-t border-white/10 bg-ink-950" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-12">
        <div className="grid gap-12 lg:grid-cols-[1.5fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <img
                src="/teamx-icon.png"
                alt="Team-X logo"
                className="h-11 w-auto object-contain drop-shadow-[0_0_12px_rgba(0,240,255,0.25)]"
              />
              <img
                src="/teamx-title-dark.png"
                alt="Team-X IT and Consulting Services"
                className="h-10 w-auto object-contain"
              />
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-zinc-500">
              Team-X IT and Consulting Services Pvt. Ltd. — engineering tomorrow's intelligent
              digital infrastructure for the enterprise.
            </p>
            <div className="mt-6 flex gap-3">
              {[Linkedin, Twitter, Github].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  aria-label="Social link"
                  data-testid={`footer-social-${i}`}
                  className="grid h-10 w-10 place-items-center rounded-lg border border-white/10 bg-white/[0.02] text-zinc-400 transition-colors duration-300 hover:border-brand/40 hover:text-brand"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {cols.map((col) => (
            <div key={col.title}>
              <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500">{col.title}</h4>
              <ul className="mt-5 flex flex-col gap-3">
                {col.links.map((l) => (
                  <li key={l}>
                    <button
                      onClick={() => go(col.title === "Company" ? `#${l.toLowerCase()}` : "#solutions")}
                      className="text-sm text-zinc-400 transition-colors duration-300 hover:text-white"
                    >
                      {l}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
          <p className="text-sm text-zinc-600">© {new Date().getFullYear()} Team-X IT and Consulting Services Pvt. Ltd. All rights reserved.</p>
          <button
            onClick={() => go("#contact")}
            data-testid="footer-cta"
            className="group inline-flex items-center gap-2 text-sm font-medium text-zinc-400 transition-colors duration-300 hover:text-brand"
          >
            Talk to Our Experts
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
      </div>
    </footer>
  );
};
